import emailjs from '@emailjs/browser';

// Initialiser EmailJS avec la clé publique
emailjs.init("v5f59SiVoUxcAQDQf");

export const sendEmail = async (data: {
  email: string;
  subject: string;
  message: string;
}) => {
  try {
    const response = await emailjs.send(
      "service_jbc9t9c", // Service ID
      "template_71jr01e", // Template ID
      {
        from_email: data.email,
        subject: data.subject,
        message: data.message,
        to_email: "comprendrelessespro@gmail.com"
      }
    );
    return response;
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};